import { Controller } from '@hotwired/stimulus'
import { anyVisible } from 'utils/any_visible'
import { isVisible } from 'utils/is_visible'
import { removeClass, toggleClass } from 'utils/toggle_class'
import { showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = [
    "container",
    "backContent",
    "previousButton",
    "nextButton",
    "selfAssessmentButton"
  ]

  cardClick(event) {
    // Prevent clicks on buttons and links from flipping the card, such as the
    // self assessment section
    if (event.target.matches("button, button *, a, a *, .c-keyboard-shortcuts")) return
    this.flip(event)
  }

  newCard(event) {
    if (this._locked()) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    removeClass(this.containerTarget, "-flipped")
  }

  beforeRequest(event){
    this.selfAssessmentButtonTargets.forEach((button) => { button.disabled = true })
  }

  flip(event) {
    if (this._locked()) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      return
    }

    toggleClass(this.containerTarget, "-flipped")

    // Hide the answer on the back of the card until it's flipped over, so the
    // user doesn't see it before they're ready
    showElement(this.backContentTarget)
  }

  keyboardEvent(event) {
    if (this._shouldIgnoreKeyboardShortcuts(event)) {
      return true
    }

    const handledKey = this._handleKey(event.key)

    if (handledKey) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  _locked() {
    return this.containerTarget.classList.contains("-locked")
  }

  _handleKey(key) {
    let handledKey = true

    switch (key) {
      case " ":
        this.flip()
        break
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
        this._clickAssessmentButton(key)
        break
      case "ArrowLeft":
        this._handleLeftArrow()
        break
      case "ArrowRight":
        this._handleRightArrow()
        break
      default:
        handledKey = false
    }

    return handledKey
  }

  _shouldIgnoreKeyboardShortcuts(event) {
    if (event.target instanceof HTMLInputElement) {
      return true
    } else if (anyVisible("[data-js-modal]:not(.c-flashcard-modal)")) {
      return true
    } else if (event.shiftKey || event.altKey || event.ctrlKey || event.metaKey) {
      return true
    }
    return false
  }

  _clickAssessmentButton(key) {
    const button = this.selfAssessmentButtonTargets.find((target) => {
      return target.dataset.assessmentValue === key && isVisible(target)
    })
    this._safeClick(button)
  }

  _handleLeftArrow() {
    this._safeClick(this._previousButton())
  }

  _handleRightArrow() {
    this._safeClick(this._nextButton())
  }

  _safeClick(button) {
    if (button && isVisible(button) && !this._locked()) button.click()
  }

  _previousButton() {
    return this.previousButtonTargets.find(isVisible)
  }

  _nextButton() {
    return this.nextButtonTargets.find(isVisible)
  }
}
